
const overrideMenuStyles = theme => ({
    MuiMenuItem: {
        styleOverrides: {
            root: {
                '&.Mui-selected': {
                    backgroundColor: theme.palette.action.selected,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                }
            }
        }
    }
})

export default overrideMenuStyles